import { useLandingV2Context } from 'detailsv2/LandingV2/context';
import { getCurrentDatePage } from 'utils/proposals';

export const useScrollToCurrentDatePage = () => {
  const { data, setActivePageId } = useLandingV2Context();
  const pages = data.landing.pages;

  const handleScrollToCurrentDatePage = () => {
    const targetPage = getCurrentDatePage(pages);
    if (!targetPage) return;

    setTimeout(() => {
      setActivePageId({ pageId: targetPage.id, notifyExternalEnv: true, withScroll: true });
    }, 0);
  };

  return { handleScrollToCurrentDatePage };
};
